import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const SmlouvaDetail = lazy(() =>
  import('@/modules/ojeta-vozidla/SmlouvaDetail').then((m) => ({ default: m.SmlouvaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/smlouvy/$id',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaDetail />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
